module.exports = __webpack_public_path__ + "static/img/P5.bcdcce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P5.png
// module id = 7pKa
// module chunks = 0